// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__-13P2","details":"Login_details__WssIY","btn":"Login_btn__Hdu7E","nav":"Login_nav__g2XLz","bottom":"Login_bottom__BvnZP"};